import Swiper, {Navigation, Thumbs, EffectFade} from 'swiper';
import {getOptionsFromJsonString} from "../../../../default/global/js/utilities/options";

Swiper.use([Navigation, Thumbs]);

function buildItemcardMainSwiper(el, options = {}, swiperThumbs = false, initialized = () => {}) {
    Swiper.use([EffectFade]);
    let swiperMainImages = new Swiper(el, {
        speed: options.eff_interval,
        loop: true,
        effect: 'fade',
        items: 1,
        thumbs: { swiper: swiperThumbs },
        on: { init: function () { initialized(); } }
    });
    return swiperMainImages;
}

function buildItemcardThumbsSwiper(el, options = {}, swiperMain) {
    let btnPrev = document.createElement("div");
    btnPrev.classList.add('swiper-button-prev');
    btnPrev.innerHTML = "<i class='icon icon-angle-left'></i>";

    let btnNext = document.createElement("div");
    btnNext.classList.add('swiper-button-next');
    btnNext.innerHTML = "<i class='icon icon-angle-right'></i>";

    el.appendChild(btnPrev);
    el.appendChild(btnNext);

    let loopedSlides = options.slidesPerViewThumbs;
    let slidesPerViewThumbs = options.slidesPerViewThumbs;
    if (window.innerWidth < GLOBALS.gridBreakpoints.sm && options.spaceBetweenThumbs > 10) {
        options.spaceBetweenThumbs = 10;
    }
    let currentDirection;
    if (window.innerWidth > options.directionBreakpoint) {
        if (options.directionThumbs === "vertical") {
            el.style.height = swiperMain.clientHeight + "px";
            el.classList.remove('swiper-horizontal');
            el.classList.add('swiper-vertical');
            currentDirection = 'vertical';
        } else {
            el.style.removeProperty('height');
            el.classList.remove('swiper-vertical');
            el.classList.add('swiper-horizontal');
            currentDirection = 'horizontal';
            slidesPerViewThumbs = "auto";
        }
    } else {
        el.style.removeProperty('height');
        el.classList.remove('swiper-vertical');
        el.classList.add('swiper-horizontal');
        currentDirection = 'horizontal';
        slidesPerViewThumbs = "auto";
        loopedSlides = 1;
    }
    let swiperThumbsImages = new Swiper(el, {
        speed: options.eff_interval,
        direction: currentDirection,
        slidesPerView: slidesPerViewThumbs,
        loop: false,
        loopedSlides: loopedSlides,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        spaceBetween: options.spaceBetweenThumbs,
        freeMode: true,
        navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev')
        }
    });
    if (currentDirection === 'horizontal') {
        for (let slide of swiperThumbsImages.slides) {
            slide.style.height = '';
        }
    }
    return swiperThumbsImages;
}

export function initItemcardImages() {
    const wrapper = document.querySelector('.js-itemcardImages');
    if (wrapper) {
        const mainImages = wrapper.querySelector('.js-itemcardImagesMain');
        const thumbsImages = wrapper.querySelector('.js-itemcardImagesThumbs');
        let swiperThumbs = true;
        let options = getOptionsFromJsonString(wrapper.getAttribute('data-options'), {
            eff_interval: 300,
            directionThumbs: "horizontal",
            directionBreakpoint: GLOBALS.gridBreakpoints.md - 1,
            slidesPerViewThumbs: 4,
            spaceBetweenThumbs: 20
        });
        if (wrapper.classList.contains('thumbsLeft') && window.innerWidth > options.directionBreakpoint) {
            options.directionThumbs = "vertical";
        }
        if (mainImages) {
            wrapper.classList.add("is-loading");
            if (thumbsImages) {
                swiperThumbs = buildItemcardThumbsSwiper(thumbsImages, options, mainImages);
            } else {
                console.error('Thumbs Images not found');
            }
            buildItemcardMainSwiper(mainImages, options, swiperThumbs, function () {
                setTimeout(function () {
                    wrapper.classList.remove("is-loading");
                    wrapper.classList.add("initialized");
                }, 200);
            });
        } else {
            console.error('Main Images not found');
        }
    }
}
